/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {AddCustomersToPoolRequest} from '@cash-web/protos/squareup/cash/pools/v1beta/pools.pb'
import {AddCustomersToPoolResponse} from '@cash-web/protos/squareup/cash/pools/v1beta/pools.pb'


export const addCustomersToPool = (request: AddCustomersToPoolRequest, options?: CashRequestOptions) => post<AddCustomersToPoolRequest, AddCustomersToPoolResponse>("/2.0/cash/add-customers-to-pool", request, {...options, rejectOnError: true })